import { useState, useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { toast } from "react-toastify"; 
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";  

const useUpdateLicenses = () => {
  const { token } = useContext(AuthContext);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate()

  const handleSubmit = async (e, formData) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const formDataToSend = new FormData();
      formData.forEach((doc) => {
        formDataToSend.append(doc.name, doc.file);
      });

      const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/vesselOwner/profile/update/licenses`, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formDataToSend,
      });

      const resData = await res.json();

      if (!res.ok) {
        throw new Error(resData.message);
      }

      setLoading(false);
      

      
      toast.success("Licenses updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000, 
      });

    
      setTimeout(() => {
        setSuccess(false);
        navigate("/updates")  
      }, 3000);
    } catch (error) {
      setError(error.message);
      setLoading(false);

      
      toast.error(`Error: ${error.message}`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
  };

  return {
    handleSubmit,
    loading,
    error,
    success,
  };
};

export default useUpdateLicenses;

